import { createGlobalStyle } from 'styled-components'

// Token files: @ironscales/design-system/styles (DS) + host-tokens.js (app / Pages chrome).
import './ckeditor.css'

export const dropdownBoxShadow = `0px 5px 14px 0px rgba(25, 72, 210, 0.20)`
export const boxShadowCard = `var(--shadow-1);`
export const boxShadowContentContainer = `0px 1px 4px 0px rgba(34, 48, 99, 0.14)`

// Align with DS 3.0 (`theme-v3.css`). Webfonts are loaded from the HTML shells /
// Storybook preview-head — do not @import extra families here.
const FONT_FAMILY = `var(--t-typography-font-family-font-family-default, 'Poppins', sans-serif)`

// html / html body beat Bootstrap's body { font-family: Helvetica Neue }
// (same element, higher specificity). * still covers every descendant so
// inherit cannot leak the Bootstrap family.
const Typography = createGlobalStyle`
  html,
  html body,
  * {
    font-family: ${FONT_FAMILY};
  }

  .typography-h1 {
    font-weight: 500;
    font-size: 25px;
    font-family: ${FONT_FAMILY};
  }

  .typography-h2 {
    font-weight: 500;
    font-size: 21px;
    font-family: ${FONT_FAMILY};
  }

  .typography-title-1 {
    font-weight: 550;
    font-size: 21px;
    font-family: ${FONT_FAMILY};
  }

  .typography-title-2 {
    font-weight: 550;
    font-size: 17px;
    font-family: ${FONT_FAMILY};
  }

  .typography-subtitle-1 {
    font-weight: 550;
    font-size: 15px;
    font-family: ${FONT_FAMILY};
  }

  .typography-subtitle-2 {
    font-weight: 600;
    font-size: 14px;
    font-family: ${FONT_FAMILY};
  }

  .typography-subtitle-3 {
    font-weight: 600;
    font-size: 13px;
    font-family: ${FONT_FAMILY};
  }

  .typography-subtitle-4 {
    font-weight: 450;
    font-size: 13px;
    font-family: ${FONT_FAMILY};
  }

  .typography-subtitle-5 {
    font-weight: 600;
    font-size: 12px;
    font-family: ${FONT_FAMILY};
  }

  .typography-body-1 {
    font-weight: 400;
    font-size: 14px;
    font-family: ${FONT_FAMILY};
  }

  .typography-body-2 {
    font-weight: 400;
    font-size: 13px;
    font-family: ${FONT_FAMILY};
  }

  .typography-body-3 {
    font-weight: 400;
    font-size: 12px;
    font-family: ${FONT_FAMILY};
  }
  .typography-subbody-3 {
    font-weight: 300;
    font-size: 12px;
    font-family: ${FONT_FAMILY};
  }

  .box-shadow-table {
    border-radius: 10px;
    box-shadow: 0px 7px 10px 0px rgba(25, 72, 210, 0.20);
  }
  .box-shadow-dropdown {
    border-radius: 10px;
    box-shadow: ${dropdownBoxShadow};
  }
  .box-shadow-card {
    border-radius: 8px;
    box-shadow: ${boxShadowCard};
  }
  .box-shadow-drawer {
    border-radius: 10px;
    box-shadow: -7px 0px 14px 1px rgba(25, 72, 210, 0.20);
  }
  .box-shadow-page-tools-section {
    border-radius: 10px;
    box-shadow: var(--shadow-2);
  }
  .box-shadow-modal {
    border-radius: 8px;
    box-shadow: var(--color-elevated-shadow);
  }
  .box-shadow-tooltip, .ant-tooltip .ant-tooltip-inner {
    border-radius: 8px;
    border: 1px solid var(--tooltip-outline);
    box-shadow: var(--tooltip-shadow);
  }

  .ant-tooltip .ant-tooltip-arrow::before {
    border: 1px solid var(--tooltip-outline);
  }

`

export default Typography
